// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY
import * as React from 'react';
import InsuranceFilledSvg from "@fishx/icons-svg/es/asn/InsuranceFilled";
import FishxIcon from '../components/FishxIcon';

var InsuranceFilled = function InsuranceFilled(props, ref) {
  return React.createElement(FishxIcon, Object.assign({}, props, {
    ref: ref,
    icon: InsuranceFilledSvg
  }));
};

InsuranceFilled.displayName = 'InsuranceFilled';
export default React.forwardRef(InsuranceFilled);


//////////////////
// WEBPACK FOOTER
// ./node_modules/@fishx/icons/es/icons/InsuranceFilled.js
// module id = 2983
// module chunks = 0